export default __webpack_public_path__ + "static/media/CivilEng_Shapes-01.55a11dd4.png";